import { ReactComponent as Logo } from "./logo.svg";

export default Logo;
